<template>
  <div class="item-wrap">
    <div class="item">
      <div class="item-pics">
        <Carousel height="344px" :list="item.sngleProductImg" :parentItem="item" type="product" />
      </div>
      <div class="item-content">
        <div class="item-head">
          <div class="title">{{ item.productName }}</div>
        </div>
        <ul class="intro">
          <li class="serve" v-if="item.serve">{{ ts('Serve')['Serve'] }}: {{ item.serve }} {{ ts('guests')['guests'] }}</li>
          <li class="duration" v-if="item.duration">{{ ts('Duration')['Duration'] }}: {{ item.duration }} {{ item.durationUnit_translate }}</li>
          <li class="cost" v-if="item.minCost">{{ ts('Cost')['Cost'] }}: {{ item.minCost }} ~</li>
          <li class="availability" v-if="item.availability">{{ ts('Availability')['Availability'] }}: {{ item.availability }}</li>
          <li class="time" v-if="item.preparationTime">{{ ts('Preparation Time')['Preparation Time'] }}: {{ item.preparationTime }}</li>
        </ul>
        <div class="item-footer">
          <el-button class="btn btn-theme2" @click="getDetail(item.singleProductId)">{{ ts('Show Detail')['Show Detail'] }}</el-button>
          <el-button class="btn btn-theme" @click="toOrder(item)" v-if="type == 'readonly'">{{ ts('ORDER')['ORDER'] }}</el-button>
          <el-button class="btn btn-theme" :loading="btnLoading" @click="showOrder(item)" v-else>{{ ts('ORDER')['ORDER'] }}</el-button>
        </div>
      </div>
    </div>
    <ProductOrder @ok="btnLoading=false" :productId="item.singleProductId" :type="type" :hotelIdDefault="hotelId" :currency="item.currency" :orderList="orderList" v-if="isShow" :productPage="productPage"/>

    <!-- 详情弹窗 -->
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" width="1000px">
      <div class="page-detail" v-if="detail">
        <el-divider>{{ ts('Introduction')['Introduction'] }}</el-divider>
        <div class="detail-intro" style="width: 660px">
          <p>
            {{ detail.pmsProduct.productContent }}
          </p>
        </div>
        <div v-if="detail.pmsProductExtraFeeList && detail.pmsProductExtraFeeList.length > 0">
          <el-divider>{{ ts('Other Fee')['Other Fee'] }}</el-divider>
          <ul class="detail-option">
            <li v-for="fee in detail.pmsProductExtraFeeList" :key="fee.id">{{ fee.name }}: {{ fee.amount }}</li>
          </ul>
        </div>
        <div v-if="detail.pmsProduct.productRule">
          <el-divider>{{ ts('Rules and Regulations')['Rules and Regulations'] }}</el-divider>
          <div class="detail-intro" style="width: 660px">
            <div v-html="detail.pmsProduct.productRule" style="white-space: pre-wrap"></div>
          </div>
        </div>
        <CancellationPolicy :detail="detail.pmsProduct" />
      </div>
    </el-dialog>

    <!-- 没预约弹窗 -->
    <el-dialog :visible.sync="noticeDialogVisible" :append-to-body="true" width="1000px">
      <div class="page-detail">
        <el-divider>{{ ts('Notice')['Notice'] }}</el-divider>
        <div class="detail-intro" style="width: 900px">
          <!-- 酒店列表 -->
          <p>
            {{ ts('This activity only provides to guest stay in')['This activity only provides to guest stay in'] }}
            <span class="link" v-for="hotel in hotelList" :key="hotel.id" @click="toHotel(hotel.id)">{{ hotel.name_translate }}</span>
          </p>
        </div>
        <div style="margin-top: 20px; text-align: center">
          <el-button class="btn btn-theme" @click="toHome">{{ ts('BOOK MY STAY !')['BOOK MY STAY !'] }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { USER_INFO } from '@/store/mutation-types'
import { getAction, postAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import Carousel from '@/components/Carousel.vue'
import ProductOrder from '@/components/ProductOrder.vue'
import CancellationPolicy from '@/components/CancellationPolicy.vue'

export default {
  name: 'ProductItem',
  mixins: [LanguagePackage],
  props: ['item', 'type', 'hotelId', 'parentId','productPage'],
  data() {
    return {
      isShow: false,
      btnLoading: false,
      detail: null,
      dialogVisible: false,
      noticeDialogVisible: false,
      hotelList: [],
      orderList: [],
    }
  },
  components: {
    Carousel,
    ProductOrder,
    CancellationPolicy,
  },
  created() {},
  methods: {
    showOrder(item) {
        this.btnLoading = true;
        console.log(item);

        if (this.type === 'order' && this.productPage.productSaleScope) {
          // 产品列表页预定，先查询是否有相关酒店订单
          getAction(`/user/api/bookingOderList`, {
            pageId: this.parentId,
          }).then((res) => {
            if (res.result && res.result.length > 0) {
              this.orderList = res.result
              this.isShow = true
            } else {
              // 没有相关订单，显示弹窗
              this.getHotelList()
              this.noticeDialogVisible = true
            }
          }).catch(e=>{
            this.getHotelList()
            this.noticeDialogVisible = true
          })
        } else {
          this.isShow = true
        }

    },
    getDetail(productMainId) {
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      getAction(`/pc/home/qryShowDetail`, {
        productMainId,
      })
        .then((res) => {
          loading.close()
          this.detail = res.result
          this.dialogVisible = true
        })
        .catch(() => {
          loading.close()
        })
    },
    toOrder(item) {
      this.$router.push(`/product/${this.parentId}?type=${item.productType}`)
    },
    // 跳转到酒店
    toHotel(id) {
      this.$router.push({ name: 'Hotel', params: { id } })
    },
    // 获取产品相关酒店列表
    getHotelList() {
      getAction(`/user/api/getHotelInfoList`, {
        productId: this.item.singleProductId,
      }).then((res) => {
        this.hotelList = res.result
      })
    },
    toHome() {
      this.$router.push('/')
    },
  },
}
</script>

<style scoped lang="sass"></style>
